
import { useState } from "react";
import { Hero } from "@/components/Hero";
import { WhyChooseUs } from "@/components/WhyChooseUs";
import { LocalGems } from "@/components/home/LocalGems";
import { PricingComparison } from "@/components/PricingComparison";
import { TrustBadges } from "@/components/TrustBadges";
import { SuperPartners } from "@/components/SuperPartners";
import { DiscoverSection } from "@/components/DiscoverSection";
import { WaitlistForm } from "@/components/WaitlistForm";

interface HomeContentProps {
  defaultIsPro?: boolean;
  showWaitlist: boolean;
  setShowWaitlist: (show: boolean) => void;
  onUserTypeChange: (isPro: boolean) => void;
}

export const HomeContent = ({ 
  defaultIsPro,
  showWaitlist,
  setShowWaitlist,
  onUserTypeChange
}: HomeContentProps) => {
  const [isPro, setIsPro] = useState(defaultIsPro ?? true);

  const handleUserTypeChange = (newIsPro: boolean) => {
    setIsPro(newIsPro);
    onUserTypeChange(newIsPro);
  };

  const handleShowWaitlist = () => {
    setShowWaitlist(true);
  };

  return (
    <>
      <Hero onUserTypeChange={handleUserTypeChange} defaultIsPro={defaultIsPro} />
      <WhyChooseUs isPro={isPro} />
      {isPro && <PricingComparison />}
      <TrustBadges isPro={isPro} />
      <LocalGems isPro={isPro} />
      {!isPro && <DiscoverSection onShowWaitlist={handleShowWaitlist} />}
      <SuperPartners isPro={isPro} onShowWaitlist={handleShowWaitlist} />
      <WaitlistForm 
        isPro={isPro} 
        open={showWaitlist} 
        onOpenChange={setShowWaitlist} 
      />
    </>
  );
};
